import { IntegrationTokenName } from '../domains/api';
import type { Integration } from '../types';

export const googleOptimize: Integration = {
  slug: 'google-optimize',
  icon: 'google_optimize',
  name: 'integrations:google_optimize.title',
  tokenName: IntegrationTokenName.GoogleOptimize,
  provider: 'integrations:card.hotjar-google',
  actionLabel: {
    autoMarkRecordings: 'integrations:details.header.google-optimize-auto-mark-recordings',
  },
  description: 'integrations:google_optimize.description-revamp',
  descriptionLarge: null,
  resources: [
    {
      copy: 'integrations:google_optimize.using-with-hotjar',
      url: '/articles/360051975733',
      icon: 'page_full',
    },
    {
      copy: 'integrations:google_optimize.hotjar-plus-optimize',
      url: 'https://support.google.com/optimize/answer/10012516?hl=en',
      icon: 'page_full',
    },
  ],
  images: null,
  videoUrl: null,
  gate: 'core.integrations',
  isEnabled: false,
  settings: null,
};
